import { SortOrder } from '@price-for-profit/micro-services';
import {
  Collapse,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Radio,
  RadioGroup,
  Switch,
  SxProps,
  Theme,
} from '@mui/material';
import { ExpandLess, ExpandMore, Search } from '@mui/icons-material';
import { ChangeEvent as ReactChangeEvent } from 'react';
import { useQuoteListState } from 'shared/contexts';
import { useToggle } from 'shared/hooks';
import { SearchableFields, SortableFields } from 'shared/types';

const filtersStyles: SxProps<Theme> = theme => ({
  marginTop: theme.spacing(),
  width: '100%',
});
interface QuoteSearchProps {
  totalCount: number;
}
export function QuoteSearch({ totalCount }: QuoteSearchProps) {
  const [show, toggleShow] = useToggle();
  const { state, setSortOrder, setSearch, setSortBy, setSearchColumn, toggleSalesRepOnly } = useQuoteListState();

  const changeSortOrder = (event: ReactChangeEvent<HTMLInputElement>) => {
    setSortOrder(event.target.value as SortOrder);
  };

  const changeSearch = (event: ReactChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const changeSortBy = (event: ReactChangeEvent<HTMLInputElement>) => {
    setSortBy(event.target.value as SortableFields);
  };

  const changeSearchColumn = (event: ReactChangeEvent<HTMLInputElement>) => {
    const column = event.target.value as SearchableFields;
    if (column === 'salesRep' && state.salesRepOnly) {
      toggleSalesRepOnly();
    }
    setSearchColumn(column);
  };
  return (
    <>
      <Input
        type='search'
        value={state?.search}
        onChange={changeSearch}
        fullWidth
        placeholder={`Search ${totalCount} Quotes...`}
        startAdornment={
          <InputAdornment component='span' position='start'>
            <Search />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment component='span' position='end'>
            <IconButton aria-label='search toggle expand' size='small' onClick={toggleShow}>
              {show ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </InputAdornment>
        }
      />
      <Collapse in={show}>
        <Grid sx={filtersStyles} spacing={2} container justifyContent='center'>
          <Grid item container justifyContent='center' xs={12} sm={6} md>
            <FormControl>
              <FormLabel>Sort Order</FormLabel>
              <RadioGroup value={state?.sortOrder} onChange={changeSortOrder}>
                <FormControlLabel label='Ascending' value='asc' control={<Radio size='small' />} />
                <FormControlLabel label='Descending' value='desc' control={<Radio size='small' />} />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item container justifyContent='center' xs={12} sm={6} md>
            <FormControl>
              <FormLabel>Sort By</FormLabel>
              <RadioGroup value={state?.sortBy} onChange={changeSortBy}>
                <FormControlLabel label='Created Date' value='createdDate' control={<Radio size='small' />} />
                <FormControlLabel label='Status' value='status' control={<Radio size='small' />} />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item container justifyContent='center' xs={12} sm={6} md>
            <FormControl>
              <FormLabel>Sales Rep</FormLabel>
              <FormControlLabel
                label='Only My Quotes'
                control={<Switch checked={state?.salesRepOnly} onChange={toggleSalesRepOnly} />}
              />
            </FormControl>
          </Grid>
          <Grid item container justifyContent='center' xs={12} sm={6} md>
            <FormControl>
              <FormLabel>Search By</FormLabel>
              <RadioGroup value={state?.searchColumn} onChange={changeSearchColumn}>
                <FormControlLabel label='Quote Number' value='quoteNumber' control={<Radio size='small' />} />
                <FormControlLabel label='Customer' value='customerSearch' control={<Radio size='small' />} />
                <FormControlLabel label='Sales Rep' value='salesRep' control={<Radio size='small' />} />
                <FormControlLabel
                  label='Assigned Sales Rep'
                  value='assignedSalesRep'
                  control={<Radio size='small' />}
                />
                <FormControlLabel label='Quote Outcome' value='outcome' control={<Radio size='small' />} />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </Collapse>
    </>
  );
}
